import React, { FC } from 'react';
import { useFieldHelper, FieldProps } from 'framework/ui/field';
import { Typography, TypographyOwnProps } from '@mui/material';
import { SCHEDULE_BILLING_STATUS_OPTIONS, ScheduleItemStatus } from '../../billingTypes';

const formatParentAlias = (parentAlias: string | undefined): string => {
  if (!parentAlias) return '';

  const positionMatch = parentAlias.match(/^(\d+)(\.\d+)?$/);
  if (positionMatch) {
    const mainPosition = positionMatch[1];
    return `period ${mainPosition}`;
  }

  return parentAlias;
};

const STATUS_COLORS: Record<string, TypographyOwnProps['color']> = {
  [ScheduleItemStatus.PLANNED]: 'textSecondary',
  [ScheduleItemStatus.APPROVED]: 'success',
  [ScheduleItemStatus.DRAFT]: 'warning',
  [ScheduleItemStatus.IN_APPROVAL]: 'warning',
  [ScheduleItemStatus.SCHEDULE_ITEM_RELATED]: 'textSecondary',
  [ScheduleItemStatus.CLARIFICATION_REQUESTED]: 'warning',
  [ScheduleItemStatus.SYSTEM_PENDING]: 'warning',
};

const StatusField: FC<FieldProps & { id: string; sourceId: string; parentAliasSource: string }> = props => {
  const { source } = props;
  const { getValue } = useFieldHelper({ source });
  const { getValue: getValueParentAlias } = useFieldHelper({ source: props.parentAliasSource });
  const parentAlias = getValueParentAlias();
  const currentStatus = getValue() as ScheduleItemStatus;

  const currentColor: TypographyOwnProps['color'] = STATUS_COLORS[currentStatus] || 'textSecondary';

  const statusOption = SCHEDULE_BILLING_STATUS_OPTIONS[currentStatus] || currentStatus;

  if (currentStatus === ScheduleItemStatus.SCHEDULE_ITEM_RELATED) {
    const formattedParentAlias = formatParentAlias(parentAlias);
    return <Typography color={currentColor}>included in {formattedParentAlias}</Typography>;
  }
  return <Typography color={currentColor}>{statusOption}</Typography>;
};
export default StatusField;
